import { OverlayAsset } from '@lib/types/OverlayAsset';
import { FileUploadParameters } from '@lib/types/FileUploads';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AccessToken } from 'common-models';
import { Configuration } from 'src/Configuration';

export interface OneTimeSigninLinkResponse {
  signinLink: string;
}

export const adminSlice = createApi({
  reducerPath: 'adminApi',
  baseQuery: fetchBaseQuery({
    baseUrl: Configuration.ApiUrl,
  }),
  tagTypes: ['Overlays'],
  endpoints: (builder) => ({
    createOneTimeSigninLink: builder.mutation<OneTimeSigninLinkResponse, string>({
      query: (email) => ({
        url: `/auth/onetimesignin/${email}`,
        method: 'POST',
        body: {},
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }),
    }),

    getAuthTokenFromOneTimeToken: builder.query<string, { oneTimeToken: string }>({
      query: (input) => ({
        url: `/auth/onetimesignin/${input.oneTimeToken}`,
      }),
      //providesTags: [{ type: 'events', id: 'all-events' }]
    }),

    getUploadParameters: builder.query<FileUploadParameters, { eventId: string; filename: string; accessToken: AccessToken; overlayKey?: string }>({
      query: (input) => {
        const url = `/admin/events/${input.eventId}/uploadurl/${input.filename}`;
        const params = new URLSearchParams();
        if (input.overlayKey) {
          params.set('overlayKey', input.overlayKey);
        }
        const queryString = params.toString();
        return {
          url: queryString ? `${url}?${queryString}` : url,
          headers: {
            Authorization: `Bearer ${input.accessToken}`,
          },
        };
      },
    }),

    listOverlays: builder.query<OverlayAsset[], { accessToken: AccessToken }>({
      query: (input) => ({
        url: '/admin/overlays',
        headers: {
          Authorization: `Bearer ${input.accessToken}`,
        },
      }),
      providesTags: ['Overlays'],
    }),
  }),
});

export const { useCreateOneTimeSigninLinkMutation, useGetAuthTokenFromOneTimeTokenQuery, useLazyGetUploadParametersQuery, useListOverlaysQuery } =
  adminSlice;
